import type { AnalyticsConsent } from './analyticsConsent.ts'

export interface AnalyticsConsentChoiceDependencies {
  persist: (consent: AnalyticsConsent) => void
  reconcilePostHog: (consent: AnalyticsConsent) => void
  reconcileGoogleAnalytics: (consent: AnalyticsConsent) => void
}

/**
 * Persist first so all shared gates (including Vercel beforeSend) close, then
 * synchronously invoke each loaded provider's shutdown path before returning
 * from a denial click. Grant initialization remains in the consent effects.
 */
export function applyAnalyticsConsentChoice(
  consent: AnalyticsConsent,
  dependencies: AnalyticsConsentChoiceDependencies
): void {
  dependencies.persist(consent)
  if (consent !== 'denied') return

  dependencies.reconcilePostHog(consent)
  dependencies.reconcileGoogleAnalytics(consent)
}
